import CryptoJS from "crypto-js";
import axios from "axios";

let reissueIsRunning = false;
export const reissue = (userId: string, url: string, navigate: any) => {
    return new Promise((resolve: any, reject) => {
        if (reissueIsRunning) {
            resolve(); // 이미 실행 중이라면 무시
            return;
        }

        reissueIsRunning = true;

        axios.get(url + "checktoken", {
            headers: {
                'Authorization': localStorage.getItem('Authorization')
            }
        })
            .then(res => {
                if (res.data === true) {
                    resolve();
                } else if (res.data === false) {
                    axios.post(url + 'reissue', {
                        userId: userId
                    }, {
                        headers: {
                            'Refresh': localStorage.getItem('Refresh')
                        }
                    }).then((response) => {
                        localStorage.setItem('Authorization', response.data.result.Authorization)
                        resolve();
                    }).catch((e) => {
                        console.log(e)
                        alert('다시 로그인해 주시기 바랍니다.');
                        localStorage.clear();
                        navigate('/')
                        reject(e);
                    })
                }
            }).finally(() => {
            reissueIsRunning = false;
        })
    })
}

export const AesEncrypt = (password: string) => {
    const secretKey = CryptoJS.enc.Utf8.parse('4a00b9d7028eaca0f0a0696d100f4396');
    const iv = CryptoJS.enc.Utf8.parse('db6bc9d7821452d9');
    return CryptoJS.AES.encrypt(password, secretKey, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: iv
    }).toString();
}